var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 110,
    viewBox: "0 0 58 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 0H0V110H58V0Z",
    fill: "#FF7F34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5144 95.6601V79.7153C42.5144 72.2174 36.3425 66.126 28.7651 66.126C21.1878 66.126 15.0159 72.2261 15.0159 79.7153V95.6601H42.5231H42.5144ZM28.3199 73.3995H28.381C31.0697 73.3995 33.2434 75.2977 33.2434 77.6359C33.2434 79.9741 31.0697 81.8723 28.381 81.8723H28.3199C25.605 81.8723 23.3964 79.9741 23.3964 77.6359C23.3964 75.2977 25.605 73.3995 28.3199 73.3995ZM23.7194 81.648L35.0941 93.7619H23.7281V81.648H23.7194ZM28.7564 68.0328C35.2775 68.0328 40.5851 73.2787 40.5851 79.7239V93.7619H38.9701L28.1628 83.7101L28.1279 83.6756C28.3548 83.7101 28.5469 83.7101 28.7651 83.7101C32.4752 83.7101 35.4782 80.9922 35.4782 77.6445C35.4782 74.2968 32.4752 71.579 28.7651 71.579C26.7486 71.579 24.959 72.3727 23.7106 73.6324L23.6757 72.1139V71.8982H20.0005C22.1655 69.5427 25.282 68.0501 28.7477 68.0501L28.7564 68.0328ZM16.9277 79.7239C16.9277 77.5669 17.53 75.5479 18.5689 73.8136H21.31L21.3274 93.7619H16.9189V79.7239H16.9277Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlap);
export default __webpack_public_path__ + "static/media/flap.8a6f3149eafc395361440db06df3fbfe.svg";
export { ForwardRef as ReactComponent };